import { compressionByField, unixToDateTime } from 'utils';
export function issuesToMessages(issue, login_link) {
    return {
        msgs: [
            ...issue.comments.map(({ author, time, comment, author_is_support }) => ({
                author,
                time,
                text: comment,
                author_is_support,
            })),
            ...issue.attachments.map(({ author, time, attachment, author_is_support, url }) => ({
                author,
                time,
                text: attachment.file_name,
                url: url ??
                    login_link +
                        `&redirect=/issues/${issue.ticket_id}/attachments/${attachment.id}`,
                author_is_support,
            })),
        ]
            .sort(compressionByField('time'))
            .map((msg) => ({
            ...msg,
            time: unixToDateTime(msg.time),
        })),
    };
}
